import { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSimpleMovingAverages } from "../../redux/actions/marketOverview";
import { getAssetExchangeNameFromMktSegId } from "../../utils/global_functions";
import { WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import { Col, Container, Row } from "react-bootstrap";
const jtenantToken = 1;
const SimpleMovingAverages = ({isVertical=true}) => {
  const simpleMovingAverages = useSelector(
    (state) => state.marketOverview.simpleMovingAverages
  );
  const scripOverviewData = useSelector(
    (state) => state.marketOverview.scripOverviewData
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (simpleMovingAverages?.length === 0) {
      dispatch(
        getSimpleMovingAverages({
          mktSegmentId: getAssetExchangeNameFromMktSegId(
            scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID]
          ),
          nToken: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
          jtenantToken: jtenantToken,
        })
      );
    }
  }, [dispatch, scripOverviewData, simpleMovingAverages]);
  //Vaibhav Singh: BT-109089: 23-10-2023:updated simple moving avergaes
  return (
    <>
    {isVertical?
      <div data-testid='market-overview-moving-averages-section' className='scripoverview-fieldset'>
        <div className='scripoverview-legend'>SIMPLE MOVING AVERAGES</div>        
          <div className='table-responsive table-fixhead scripoverview-fieldset-sm'>           
              <table data-testid="market-overview-moving-averages-table" className='table table-hover table-striped mt-3'>
                <thead>
                  <tr>
                    <th className='font-regular font-size2 table-th-color-text text-left col-md-4'>Averages</th>
                    <th className='font-regular font-size2 table-th-color-text text-center col-md-4'>NSE</th>
                    <th className='font-regular font-size2 table-th-color-text text-center col-md-4'>BSE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className='font-regular font-size2 table-td-color-subtext text-left col-md-4'>15 Days</td>
                    <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageNSE?.avg_15days ? simpleMovingAverages?.movingAverageNSE?.avg_15days : '-'}</td>
                    <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageBSE?.avg_15days ? simpleMovingAverages?.movingAverageBSE?.avg_15days : '-'}</td>
                  </tr>
                  <tr>
                    <td className='font-regular font-size2 table-td-color-subtext text-left col-md-4'>20 Days</td>
                    <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageNSE?.avg_20days ? simpleMovingAverages?.movingAverageNSE?.avg_20days : '-'}</td>
                    <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageBSE?.avg_20days ? simpleMovingAverages?.movingAverageBSE?.avg_20days : '-'}</td>
                  </tr>
                  <tr>
                    <td className='font-regular font-size2 table-td-color-subtext text-left col-md-4'>30 Days</td>
                    <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageNSE?.avg_30days ? simpleMovingAverages?.movingAverageNSE?.avg_30days : '-'}</td>
                    <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageBSE?.avg_30days ? simpleMovingAverages?.movingAverageBSE?.avg_30days : '-'}</td>
                  </tr>
                  <tr>
                    <td className='font-regular font-size2 table-td-color-subtext text-left col-md-4'>50 Days</td>
                    <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageNSE?.avg_50days ? simpleMovingAverages?.movingAverageNSE?.avg_50days : '-'}</td>
                    <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageBSE?.avg_50days ? simpleMovingAverages?.movingAverageBSE?.avg_50days : '-'}</td>
                  </tr>
                  <tr>
                    <td className='font-regular font-size2 table-td-color-subtext text-left col-md-4'>100 Days</td>
                    <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageNSE?.avg_100days ? simpleMovingAverages?.movingAverageNSE?.avg_100days : '-'}</td>
                    <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageBSE?.avg_100days ? simpleMovingAverages?.movingAverageBSE?.avg_100days : '-'}</td>
                  </tr>
                  <tr>
                    <td className='font-regular font-size2 table-td-color-subtext text-left col-md-4'>150 Days</td>
                    <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageNSE?.avg_150days ? simpleMovingAverages?.movingAverageNSE?.avg_150days : '-'}</td>
                    <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageBSE?.avg_150days ? simpleMovingAverages?.movingAverageBSE?.avg_150days : '-'}</td>
                  </tr>
                  <tr>
                    <td className='font-regular font-size2 table-td-color-subtext text-left col-md-4'>200 Days</td>
                    <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageNSE?.avg_200days ? simpleMovingAverages?.movingAverageNSE?.avg_200days : '-'}</td>
                    <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageBSE?.avg_200days ? simpleMovingAverages?.movingAverageBSE?.avg_200days : '-'}</td>
                  </tr>
                </tbody>
              </table>                      
        </div>
      </div>
      : //Changes for Sidetray
      <Container fluid className='p-0'>
        <Row className='g-0'>
          <Col>
             <div className='font-medium font-size2 color-text'>Simple Moving Averages</div>
          </Col>
        </Row>
        <Row className='g-0'>
            <Col>      
                <div className='table-responsive table-fixhead'>           
                      <table className='table table-hover table-striped'>
                        <thead>
                          <tr>
                            <th className='font-regular font-size2 table-th-color-text text-left col-md-4'>Averages</th>
                            <th className='font-regular font-size2 table-th-color-text text-center col-md-4'>NSE</th>
                            <th className='font-regular font-size2 table-th-color-text text-center col-md-4'>BSE</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className='font-regular font-size2 table-td-color-subtext text-left col-md-4'>15 Days</td>
                            <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageNSE?.avg_15days ? simpleMovingAverages?.movingAverageNSE?.avg_15days : '-'}</td>
                            <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageBSE?.avg_15days ? simpleMovingAverages?.movingAverageBSE?.avg_15days : '-'}</td>
                          </tr>
                          <tr>
                            <td className='font-regular font-size2 table-td-color-subtext text-left col-md-4'>20 Days</td>
                            <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageNSE?.avg_20days ? simpleMovingAverages?.movingAverageNSE?.avg_20days : '-'}</td>
                            <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageBSE?.avg_20days ? simpleMovingAverages?.movingAverageBSE?.avg_20days : '-'}</td>
                          </tr>
                          <tr>
                            <td className='font-regular font-size2 table-td-color-subtext text-left col-md-4'>30 Days</td>
                            <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageNSE?.avg_30days ? simpleMovingAverages?.movingAverageNSE?.avg_30days : '-'}</td>
                            <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageBSE?.avg_30days ? simpleMovingAverages?.movingAverageBSE?.avg_30days : '-'}</td>
                          </tr>
                          <tr>
                            <td className='font-regular font-size2 table-td-color-subtext text-left col-md-4'>50 Days</td>
                            <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageNSE?.avg_50days ? simpleMovingAverages?.movingAverageNSE?.avg_50days : '-'}</td>
                            <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageBSE?.avg_50days ? simpleMovingAverages?.movingAverageBSE?.avg_50days : '-'}</td>
                          </tr>
                          <tr>
                            <td className='font-regular font-size2 table-td-color-subtext text-left col-md-4'>100 Days</td>
                            <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageNSE?.avg_100days ? simpleMovingAverages?.movingAverageNSE?.avg_100days : '-'}</td>
                            <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageBSE?.avg_100days ? simpleMovingAverages?.movingAverageBSE?.avg_100days : '-'}</td>
                          </tr>
                          <tr>
                            <td className='font-regular font-size2 table-td-color-subtext text-left col-md-4'>150 Days</td>
                            <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageNSE?.avg_150days ? simpleMovingAverages?.movingAverageNSE?.avg_150days : '-'}</td>
                            <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageBSE?.avg_150days ? simpleMovingAverages?.movingAverageBSE?.avg_150days : '-'}</td>
                          </tr>
                          <tr>
                            <td className='font-regular font-size2 table-td-color-subtext text-left col-md-4'>200 Days</td>
                            <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageNSE?.avg_200days ? simpleMovingAverages?.movingAverageNSE?.avg_200days : '-'}</td>
                            <td className='font-medium font-size2 table-td-color-text text-center col-md-4'>{simpleMovingAverages?.movingAverageBSE?.avg_200days ? simpleMovingAverages?.movingAverageBSE?.avg_200days : '-'}</td>
                          </tr>
                        </tbody>
                      </table>                      
                </div>      
            </Col>
        </Row>
      </Container>   
      
      }
    </>
  );
};

export default memo(SimpleMovingAverages);
